import Vue from 'vue'
import Router from 'vue-router'
// import index from '@/components/index'
// import content from '@/page/content'
// import zmj from '@/page/zmj'
Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/test',
      name: '/test',     //path别名，可删除changePsw
      meta:{
        title: '登陆'   //设置页面title
      },
      component:()=>import('@/components/test'),
    },
    {
      path: '/test1',
      name: '/test1',     //path别名，可删除changePsw
      meta:{
        title: '登陆'   //设置页面title
      },
      component:()=>import('@/components/test1'),
    },
    {
      path: '/login',
      name: 'login',     //path别名，可删除changePsw
      meta:{
        title: '登陆'   //设置页面title
      },
      component:()=>import('@/components/login'),
    },
    {
      path: '/',
      name: 'index',     //path别名，可删除
      meta:{
        title: '首页'   ,//设置页面title
        requireAuth:true
      },
      component:()=>import('@/components/index'),
    },
    {
      path: '/exam',
      name: 'exam',     //path别名，可删除
      meta:{
        title: '考试',   //设置页面title
        requireAuth:true
      },
      component:()=>import('@/components/exam'),
    },
    {
      path: '/examInfo',
      name: 'examInfo',     //path别名，可删除
      meta:{
        title: '考试详情',   //设置页面title
        requireAuth:true
      },
      component:()=>import('@/components/examInfo'),
    },
    {
      path: '/exercises',
      name: 'exercises',     //path别名，可删除
      meta:{
        title: '练习'   ,//设置页面title
        requireAuth:true
      },
      component:()=>import('@/components/exercises'),
    },
    {
      path: '/learn',
      name: 'learn',     //path别名，可删除
      meta:{
        title: '学习',   //设置页面title
        requireAuth:true
      },
      component:()=>import('@/components/learn'),
    },
    {
      path: '/changePsw',
      name: 'changePsw',     //path别名，可删除changePsw
      meta:{
        title: '修改密码',   //设置页面title
        requireAuth:true
      },
      component:()=>import('@/components/changePsw'),
    },
    {
      path: '/myMaterials',
      name: 'myMaterials',     //path别名，可删除changePsw
      meta:{
        title: '我的资料',   //设置页面title
        requireAuth:true
      },
      component:()=>import('@/components/myMaterials'),
    },
    {
      path: '/myCourse',
      name: 'myCourse',     //path别名，可删除changePsw
      meta:{
        title: '我的课程' ,  //设置页面title
        requireAuth:true
      },
      component:()=>import('@/components/myCourse'),
    },
    {
      path: '/record',
      name: 'record',     //path别名，可删除changePsw
      meta:{
        title: '考试记录' ,  //设置页面title
        requireAuth:true
      },
      component:()=>import('@/components/record'),
    },
    {
      path: '/collection',
      name: 'collection',     //path别名，可删除changePsw
      meta:{
        title: '收藏本' ,  //设置页面title
        requireAuth:true
      },
      component:()=>import('@/components/collection'),
    },
    {
      path: '/errors',
      name: 'errors',     //path别名，可删除changePsw
      meta:{
        title: '错题本'  , //设置页面title
        requireAuth:true
      },
      component:()=>import('@/components/errors'),
    },
    {
      path: '/error',
      name: 'error',     //path别名，可删除changePsw
      meta:{
        title: '考试错题'  , //设置页面title
        requireAuth:true
      },
      component:()=>import('@/components/error'),
    },
    {
      path: '/everyDay',
      name: 'everyDay',     //path别名，可删除changePsw
      meta:{
        title: '每日一练' ,  //设置页面title
        requireAuth:true
      },
      component:()=>import('@/components/everyDay'),
    },
    {
      path: '/everyDayExam',
      name: 'everyDayExam',     //path别名，可删除changePsw
      meta:{
        title: '每日一练' ,  //设置页面title
        requireAuth:true
      },
      component:()=>import('@/components/everyDayExam'),
    },
    {
      path: '/knowledge',
      name: 'knowledge',     //path别名，可删除changePsw
      meta:{
        title: '知识点练习'   //设置页面title
      },
      component:()=>import('@/components/knowledge'),
    },
    {
      path: '/knowledgeExam',
      name: 'knowledgeExam',     //path别名，可删除changePsw
      meta:{
        title: '知识点考题'   //设置页面title
      },
      component:()=>import('@/components/knowledgeExam'),
    },
    {
      path: '/chapter',
      name: 'chapter',     //path别名，可删除changePsw
      meta:{
        title: '章节练习'  , //设置页面title
        requireAuth:true
      },
      component:()=>import('@/components/chapter'),
    },
    {
      path: '/choice',
      name: 'choice',     //path别名，可删除changePsw
      meta:{
        title: '选择题' ,  //设置页面title
        requireAuth:true
      },
      component:()=>import('@/components/choice'),
    },
    {
      path: '/choicePage',
      name: 'choicePage',     //path别名，可删除changePsw
      meta:{
        title: '选择题' ,  //设置页面title
        requireAuth:true
      },
      component:()=>import('@/components/choicePage'),
    },
    {
      path: '/choiceError',
      name: 'choiceError',     //path别名，可删除changePsw
      meta:{
        title: '考试错题详情' ,  //设置页面title
        requireAuth:true
      },
      component:()=>import('@/components/choiceError'),
    },
    {
      path: '/gapFilling',
      name: 'gapFilling',     //path别名，可删除changePsw
      meta:{
        title: '填空题' ,  //设置页面title
        requireAuth:true
      },
      component:()=>import('@/components/gapFilling'),
    },
    {
      path: '/gapFillingError',
      name: 'gapFillingError',     //path别名，可删除changePsw
      meta:{
        title: '考试错题详情' ,  //设置页面title
        requireAuth:true
      },
      component:()=>import('@/components/gapFillingError'),
    },
    {
      path: '/gapFillingPage',
      name: 'gapFillingPage',     //path别名，可删除changePsw
      meta:{
        title: '填空题' ,  //设置页面title
        requireAuth:true
      },
      component:()=>import('@/components/gapFillingPage'),
    },
    {
      path: '/currentExam',
      name: 'currentExam',     //path别名，可删除changePsw
      meta:{
        title: '考试' ,  //设置页面title
        requireAuth:true
      },
      component:()=>import('@/components/currentExam'),
    },
    {
      path: '/chapterExam',
      name: 'chapterExam',     //path别名，可删除
      meta:{
        title: '章节练习题'   ,//设置页面title
        requireAuth:true
      },
      component:()=>import('@/components/chapterExam'),
    },
    // {
    //   path: '/content/:id',
    //   name: '详情',
    //   meta:{
    //     title: '详情'
    //   },
    //   component: content
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js